import { Column } from "styled-grid-system-component"
import React from "react"
import Styles from "../SharedComponents"
import styled from "styled-components"

const JobList = styled.ul`
  list-style: none;
  border-left: 5px solid black;
  border-radius: 5px;
  padding-left: 15px;
`

const JobItem = styled.li`
  margin-bottom: 15px;
`

const JobHeader = styled.h5`
  font-size: 24px;
  margin-bottom: 10px;
  line-height: 32px;
`

const JobLink = styled.a`
  text-decoration: underline;
`

const JobDuration = styled.span`
  color: grey;
  font-size: 18px;
  margin-left: 15px;
`

const JobFull = styled.div`
  margin-bottom: 15px;
`

const JobDivider = styled.hr`
  margin: 15px;
  border: 1px dashed #ccc;
`

const JobExperience = () => {
  return (
    <Styles.RowMargined>
      <Column xs={12}>
        <Styles.Header>Relevant Job experience</Styles.Header>
        <JobList>
        <JobItem>
            <JobHeader>
              Frontend Engineer | {" "}
              <JobLink href="https://canva.com/" target="_blank">
                Canva
              </JobLink>
              <JobDuration>Nov '22 - now</JobDuration>
            </JobHeader>
          </JobItem>
          <JobItem>
            <JobHeader>
              Software Engineer | Team/TechLead at{" "}
              <JobLink href="https://dashbouquet.com/" target="_blank">
                DashBouquet
              </JobLink>
              <JobDuration>Sep '18 - Aug '22</JobDuration>
            </JobHeader>
            <JobFull>
              <JobFull>
                - Designed and implemented pipeline to collect and visualize 1M+
                records per day
              </JobFull>
              <JobFull>
                - Optimized and reduced device network traffic by 30-100 times
                through data aggregation and compression
              </JobFull>
              <JobFull>
                - Trained NN to perform highly accurate real-time age and gender
                estimation (98.5% – gender and 61% – age)
              </JobFull>
              <JobFull>
                - Innovated math-based people-tracking algorithm for computer
                vision data, which allowed to track up to 6 persons in a frame
                without loosing performance
              </JobFull>
              <JobFull>
                - Created 30+ small-to-medium applications for interactive
                screens, 3 complicated dashboards using React.JS
              </JobFull>
              <JobFull>
                - Developed 3 applications with 3D-environment and physics using
                Three.JS and WebGL
              </JobFull>
              <JobFull>
                - Implemented pipeline to generate custom Linux distribution
                kits with automatic installation, which saved about 30 mins per
                single setup
              </JobFull>
              <JobFull>
                - Overhauled and reconfigured the obsolete legacy source code of
                production application, resulting in 2 times faster deployment
                pipeline and increased development speed by an order of
                magnitude
              </JobFull>
              <JobFull>
                - Spearheaded teams from 2 to 8 engineers and combined project
                management role at 3 projects
              </JobFull>
              <JobFull>
                - Interviewed more than 50 candidates for engineering positions
                in the company, guided newcomers through the onboarding process
                and prepared for the first assignments
              </JobFull>
              <JobFull>
                - Facilitated 4 technical workshops for software engineers to
                introduce new technologies
              </JobFull>
            </JobFull>
          </JobItem>
          <JobDivider />
          <JobItem>
            <JobHeader>
              Web developer at{" "}
              <JobLink href="http://paprikash.works/" target="_blank">
                Paprikash Studio
              </JobLink>
              <JobDuration>Jul '17 - Sep '18</JobDuration>
            </JobHeader>
            <JobFull>
              - Performed hundreds of adjustments and feature-implementations of
              different complexity for 20+ e-commerce projects
            </JobFull>
            <JobFull>- Launched more than 10 landing pages</JobFull>
            <JobFull>
              - Produced more than 10 interactive and responsive and
              SEO-friendly landing pages
            </JobFull>
            <JobFull>
              - Designed and coded an application for work wear management in
              production that helps saving 1-2 hours a day for storekeepers
            </JobFull>
            <JobFull>
              - Developed front-end of web service for searching and buying
              tickets (buses, trains, planes)
            </JobFull>
          </JobItem>
          <JobDivider />
          <JobItem>
            <JobHeader>
              Storekeeper at{" "}
              <JobLink href="http://www.promagropack2007.by/" target="_blank">
                PromAgroPack-2007
              </JobLink>
              <JobDuration>Jul '15 - Jul '17</JobDuration>
            </JobHeader>
            <JobFull>
              - Created internal web-based software for production processes
              automation that provides seamless communication with 5 different
              departments
            </JobFull>
          </JobItem>
        </JobList>
      </Column>
    </Styles.RowMargined>
  )
}

export default JobExperience
